module.exports = __webpack_public_path__ + "static/media/03.69ee9036.jpeg";